import React from 'react';

import { Box, Tooltip } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { REPORT_STATUS_CONFIG } from '../constants';

import ReportStatusIcon from './ReportStatusIcon';

const ReportStatus = ({ iconSize = 16, status }) => {
    const { t } = useTranslation();

    const statusConfig = REPORT_STATUS_CONFIG[status];

    if (!statusConfig) return null;

    return (
        <Tooltip placement="top" title={t(statusConfig.label)}>
            <Box display="flex">
                <ReportStatusIcon iconSize={iconSize} status={status} />
            </Box>
        </Tooltip>
    );
};

ReportStatus.propTypes = {
    iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ReportStatus;
